import clone from 'clone'
import view from '@/mixins/view'

import RAF from '@/js/utils/raf'
import WebglManager from '@/glxp/webglManager'

import Draggable from 'gsap/Draggable'
import HomeSceneMobile from '@/glxp/scenes/homeSceneMobile'

import { populate, sort } from '@/data'
import { TweenMax } from 'gsap'

require('@/js/greensock/plugins/ThrowPropsPlugin')

const TITLE_SPEED = 0.2
const PIN_ROT_SPEED = 0.2

export default {
  name: 'tpl-home',
  mixins: [view],
  data () {
    return {
      page: null,
      paused: true,
      poles: [],
      isSafari: false,
      accelerator: false
    }
  },
  watch: {
    platform(val) {
      if(val === 'mobile') {
        setTimeout(() => {
          this.initSlider()
        }, 1000)
      }
    }
  },

  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.ready = true
      this.$nextTick(() => {
        // this.observer = new IntersectionObserver(observables => {
        //   if (observables[0].intersectionRatio > 0.1) {
        //     this.paused = false
        //   } else {
        //     this.paused = true
        //   }
        // }, {
        //   threshold: [0.1, 0.9]
        // })
        // this.observer.observe(this.$refs['home-header'])
        this.paused = false

        // this.initScrollTitle()
        this.initWebglXP()
        RAF.suscribe('home', this.update.bind(this), 20)
        RAF.suscribe('home-webgl', this.updateWebgl.bind(this))
        this.glxp.start()
        this.isSafari = this.$store.state.ua.browser.name === 'Safari'
        if (this.platform === 'mobile') {
          this.initSlider()
        }
        // console.log('DEVICE PERMISSION', DeviceMotionEvent)
      })
    })
  },
  beforeDestroy () {
    RAF.unsuscribe('home')
    RAF.unsuscribe('home-webgl')
    window.removeEventListener('resize', this.resize)
    this.observer && this.observer.unobserve(this.$refs['home-header'])
    WebglManager.desactivate('home')

  },
  destroyed () {
    RAF.unsuscribe('home')
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get('page', params.post_id),
        store.getters.get('post'),
        store.getters.get('pole'),
        store.getters.get('expertise'),
        store.getters.get('work'),
        store.getters.get('partner')
      ]).then(([page, posts, poles, expertises, works, partners]) => {
        return { page, posts, poles, expertises, works, partners }
      })
    },
    getPage: async function () {
      await this.fetchData(this.$store, this.$attrs).then(({ page, posts, poles, expertises, works, partners }) => {
        works = populate(works, partners, 'partner')

        expertises = sort(expertises, 'position', 'asc')

        poles = sort(poles, 'position', 'asc')
        poles = populate(poles, works, 'work')
        poles = populate(poles, expertises, 'pole', 'expertises')

        page = clone(page)
        page.meta.pushs.forEach(async (push) => {
          if (push.post) {
            const post = await this.$store.getters.get('post', push.post)
            if (post) {
              push.post = post
            }
            let industry
            if (!post) {
              industry = await this.$store.getters.get('industry', push.post)
            }
            if (industry) {
              push.post = industry
            }
          }
        })

        this.poles = poles
        this.page = page
      })
    },
    initSlider () {
      const snaps = this.$refs['push-link'].map((push, index) => {
        const boundings = push.getBoundingClientRect()
        return -boundings.x + Math.abs(index - (this.$refs['push-link'].length - 1)) * window.innerWidth * 0.0625
      })
      this.draggable = new Draggable(this.$refs['push-wrapper'], {
        type: 'x',
        zIndexBoost: false,
        throwProps: true,
        maxDuration: 0.5,
        edgeResistance: 1,
        bounds: {
          minX: 0,
          maxX: snaps[snaps.length - 1]
        },
        snap: {
          x: snaps
        }
      })
    },
    // initScrollTitle(){
    //   let titles = this.$refs["home-push-works-link-bg-title"]
    //   this.height = window.innerHeight
    //   this.titles = []
    //   for (let i = 0; i < titles.length; i++) {
    //     const title = titles[i];
    //     this.titles.push({
    //       dom: title,
    //       bounds: title.getBoundingClientRect(),
    //       offset: 0
    //     })
    //   }
    // },
    initWebglXP () {
      this.glColor = this.convertColor(this.page.meta.cover_color)

      if (this.mobile) {
        this.glxp = new HomeSceneMobile(this.$refs['home-header'])
        this.glxp.load()
      } else {
        this.glxp = WebglManager.getScene('home')
      }

      if (this.glColor) {
        this.glxp.loadColor(this.glColor)
      }

      WebglManager.setStyle({
        zIndex: -1,
        pointerEvents: 'none',
        opacity: 0
      })

      if (this.mobile) {
        this.$refs['home-header-canvas'].style.display = 'none'
      } else {
        WebglManager.loadScene('home')
        WebglManager.setHeight(this.$refs['home-header'].offsetHeight)
        WebglManager.activate('home')
        this.$nextTick(() => {
          WebglManager.recomputeBounds()
        })
        // setTimeout(() => {
        //   WebglManager.recomputeBounds()
        // }, 5000)
      }

      this.headerCanvas = this.$refs['home-header-canvas']
      this.ctx = this.headerCanvas.getContext('2d')
      this.resize()

      window.addEventListener('resize', this.resize)

      this.$refs['home-header'].addEventListener('mousemove', (event) => {
        this.glxp.cursorTarget[0] = event.clientX / ((this.glxp.width / this.glxp.dpr))
        this.glxp.cursorTarget[1] = event.clientY / ((this.glxp.height / this.glxp.dpr))
      })
      this.$refs['home-header'].addEventListener('touchmove', (event) => {
        event.preventDefault()
        this.glxp.cursorTarget[0] = event.touches[0].clientX / ((this.glxp.width / this.glxp.dpr))
        this.glxp.cursorTarget[1] = event.touches[0].clientY / ((this.glxp.height / this.glxp.dpr))
      })
      if (window.DeviceMotionEvent == undefined) {
        // console.log("no accelerometer");
      } else {
        // console.log("accelerometer found");
        if (typeof DeviceMotionEvent.requestPermission === 'function') {
          // window.addEventListener('touchstart', this.movePermission)
          window.addEventListener('devicemotion', (event) => {
            this.accelerator = true
            let motion = event.accelerationIncludingGravity
            this.glxp.cursorTarget[0] = motion.x * this.glxp.config.power_mobile_shake.value
            this.glxp.cursorTarget[1] = motion.y * this.glxp.config.power_mobile_shake.value
          })
        } else {
          window.addEventListener('devicemotion', (event) => {
            this.accelerator = true
            let motion = event.accelerationIncludingGravity
            this.glxp.cursorTarget[0] = motion.x * this.glxp.config.power_mobile_shake.value
            this.glxp.cursorTarget[1] = motion.y * this.glxp.config.power_mobile_shake.value
          })
        }
      }

      this.paused = false
    },
    updateWebgl () {
      if (this.mobile) {
        this.glxp.render()
      } else {
        if (!this.paused) {
          this.ctx.drawImage(this.glxp.canvas, 0, 0, this.headerWidth, this.headerHeight)
        }
      }
    },
    movePermission () {
      DeviceMotionEvent.requestPermission()
        .then(response => {
          console.log(response)
          if (response == 'granted') {
            this.accelerator = true
            window.addEventListener('devicemotion', (event) => {
              let motion = event.accelerationIncludingGravity
              this.glxp.cursorTarget[0] = motion.x * this.glxp.config.power_mobile_shake.value
              this.glxp.cursorTarget[1] = motion.y * this.glxp.config.power_mobile_shake.value
            })
          }
        })
        .catch(console.error)
    },

    resize () {
      let el = this.$refs['home-header']
      window.innerWidth < 2000  ? this.dpr = Math.min(window.devicePixelRatio, 2) : this.dpr = Math.min(window.devicePixelRatio, 1)
      this.headerWidth = el.offsetWidth * this.dpr
      this.headerHeight = el.offsetHeight * this.dpr
      this.headerCanvas.width = this.headerWidth
      this.headerCanvas.height = this.headerHeight
      this.headerCanvas.style.maxWidth = el.offsetWidth + 'px'
      this.headerCanvas.style.maxHeight = el.offsetHeight + 'px'
    },

    update () {
      if (!this.paused) {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
        // if (!this.mobile) {
        //   for (let i = 0; i < this.titles.length; i++) {
        //     const title = this.titles[i];
        //     const yOffset = (title.bounds.top - this.scrollTop) - this.height
        //     if (yOffset < 0) {
        //       title.dom.style.transform = `translate3d(${(yOffset * TITLE_SPEED)}px, 0px, 0)`
        //     }
        //   }
        // }
        let speed
        this.mobile ? speed = 1 : speed = this.scrollTop * PIN_ROT_SPEED
        const rot = (RAF.timeElapsed / 1000) * 30 + speed
        this.$refs['home-sub-header-pin'].style.transform = `rotate(${rot}deg)`
      }
    },
    mouseenter (item) {
      this.$refs[`link${item}`].map(el => {
        el.mouseenter()
      })
      // this.$refs[`link${item}`][0].mouseenter()
    },
    mouseleave (item) {
      this.$refs[`link${item}`].map(el => {
        el.mouseleave()
      })
    },

    handleClick(e) {
      e.srcElement.querySelector('.home-push-works-link-image').classList.add('clicked')
      //TweenMax.to(e.srcElement.querySelector('.home-push-works-link-image'), 0.2, {scale: 1})
    },
    convertColor (hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? [
        parseInt(result[1], 16) / 255,
        parseInt(result[2], 16) / 255,
        parseInt(result[3], 16) / 255
      ] : null
    }
  }
}
